import jQuery from "jquery";

import { isFormat, isFDA, isLegacyFDA, isCanadian, is100Gram } from "./format.js";
import { allSliders } from "./sliders.js";
import { showOptionalNutrientToggles } from "./optional_nutrient_toggles.js";

const $ = jQuery;

const OPEN_SECTIONS_KEY = "recipe.openSections";

const openSections = () =>
  Array.from(
    document.querySelectorAll("#recipe-option-toggles .panel.is-active .panel-heading")
  ).map((el) => el.id);

const saveOpenSections = () => window.sessionStorage.setItem(OPEN_SECTIONS_KEY, openSections());
const getOpenSections = () => {
  const sections = window.sessionStorage.getItem(OPEN_SECTIONS_KEY);
  return sections ? sections.split(",") : [];
};

const applyDualColumnSliderVisibility = ({ singleSlider, dualSliders, dualColumn }) => {
  jQuery(singleSlider).toggle(!dualColumn);
  jQuery(dualSliders).toggle(dualColumn);
  jQuery("#slider-size2").toggle(dualColumn);
};

export const syncDualColumnSliders = () => {
  if (isFormat("fda/adult/vertical")) {
    applyDualColumnSliderVisibility({
      singleSlider: "#newverticalslider",
      dualSliders: "#newdualsliderleft, #newdualsliderright",
      dualColumn: jQuery("#newdualnutritionfactstable").length > 0,
    });
  } else if (isFormat("fda/adult/tabular")) {
    applyDualColumnSliderVisibility({
      singleSlider: "#newtabularslider",
      dualSliders: "#newdualtabularsliderleft, #newdualtabularsliderright",
      dualColumn: jQuery("#new_tabular_dual_nutrient_cols").length > 0,
    });
  }
};

export const showOpenSections = () => {
  for (const id of getOpenSections()) {
    const section = document.getElementById(id);
    if (section.checkVisibility()) section.click();
  }
};

/* Bind event handlers for section slide-down widgets */
export const initializeSections = () => {
  // We must unbind all the 'click' listeners to avoid a toggle bug if initializeSections is called
  // again (which happens when the label format is changed, for example).
  jQuery("#defaultsettingsslidedown").off("click");
  jQuery("#vitaminslidedown").off("click");
  jQuery("#nutrientsslidedown").off("click");
  jQuery("#overrides-slidedown").off("click");
  jQuery("#regularlabeloptionsslidedown").off("click");
  jQuery("#extrasectionsslidedown").off("click");

  jQuery("#defaultsettingsslidedown").on("click", () => {
    // logic for both showing and hiding
    if (jQuery("#defaultsettingsoptions").is(":hidden")) {
      jQuery("#defaultsettingsoptions").slideDown("fast");
      jQuery("#defaultsettings-chevron").addClass("rotate-90");
    } else {
      jQuery("#defaultsettingsoptions").hide("fast");
      jQuery("#defaultsettings-chevron").removeClass("rotate-90");
    }
  });

  //Show optional vitamins options on click
  jQuery("#vitaminslidedown").on("click", () => {
    // logic for both showing and hiding
    if (jQuery("#optionalvitaminsdiv").is(":hidden")) {
      jQuery("#optionalvitaminsdiv").slideDown("fast");
      jQuery("#vitaminoption-chevron").addClass("rotate-90");

      // hide vitamins that don't apply for infant/child labels
      if (isFormat("legacy_fda/infant/vertical") || isFormat("legacy_fda/child/vertical")) {
        jQuery(
          ".seleniumtoggle, .manganesetoggle, .vitaminKtoggle, .vitaminAtoggle, .vitaminCtoggle"
        ).hide();
        jQuery(".vitaminDtoggle").show();
      }
      // some vitamins are now mandatory while others are optional
      else if (
        isFormat("fda/adult/vertical") ||
        isFormat("fda/adult/tabular") ||
        isFormat("fda/adult/linear") ||
        isFormat("fda/infant/vertical") ||
        isFormat("fda/child/vertical") ||
        isFormat("fda/adult/vertical/as_prepared") ||
        isFormat("fda/adult/vertical/aggregate")
      ) {
        jQuery(".vitaminAtoggle, .vitaminCtoggle").show();
        jQuery(".vitaminDtoggle").hide();
      } else if (isCanadian()) {
        // FIXME: selenium/manganese/vitamink
        jQuery(".vitaminAtoggle, .vitaminCtoggle, .vitaminDtoggle").show();
      } else {
        jQuery(".seleniumtoggle, .manganesetoggle, .vitaminKtoggle, .vitaminDtoggle").show();
        jQuery(".vitaminAtoggle, .vitaminCtoggle").hide();
      }
    } else {
      jQuery("#optionalvitaminsdiv").hide("fast");
      jQuery("#vitaminoption-chevron").removeClass("rotate-90");
    }
  });

  //Show optional nutrients on click
  jQuery("#nutrientsslidedown").on("click", () => {
    // logic for both showing and hiding
    if (jQuery("#optionalnutrientsdiv").is(":hidden")) {
      jQuery("#optionalnutrientsdiv").slideDown("fast");
      jQuery("#labeloption-chevron").addClass("rotate-90");

      showOptionalNutrientToggles();
    } else {
      jQuery("#optionalnutrientsdiv").hide("fast");
      jQuery("#labeloption-chevron").removeClass("rotate-90");
    }
  });

  jQuery("#overrides-slidedown").on("click", () => {
    if (jQuery("#overrides-div").is(":hidden")) {
      jQuery("#overrides-div").slideDown("fast");
      jQuery("#overrides-chevron").addClass("rotate-90");
    } else {
      jQuery("#overrides-div").hide("fast");
      jQuery("#overrides-chevron").removeClass("rotate-90");
    }
  });

  //Show regular label display options (color, width, formatting) on click
  jQuery("#regularlabeloptionsslidedown").on("click", () => {
    // logic for both showing and hiding
    if (jQuery("#regularlabeloptions").is(":hidden")) {
      jQuery("#regularlabeloptions").slideDown("fast");
      jQuery("#regularlabelwidth-chevron").addClass("rotate-90");
      jQuery("#slider-size2").hide();

      allSliders().hide();

      jQuery("#as-packaged-description, #as-prepared-description").hide();
      jQuery("#as-prepared-serving-size").hide();

      if (is100Gram()) {
        jQuery("#serving-size").hide();
      }

      if (isFormat("legacy_fda/adult/linear")) {
        jQuery("#linearslider").show();

        jQuery(".remove-uppercase, .make-lowercase, .make-titlecase").show();
        jQuery(
          "#regularlabeltextcolor, #regularlabelbackgroundcolor, #regularlabeltransparentbackground"
        ).show();
        jQuery(".single-serving, .servings-varied").show();
      } else if (isFormat("fda/adult/linear")) {
        jQuery("#newlinearslider").show();

        jQuery(".remove-uppercase, .make-lowercase, .make-titlecase").show();
        jQuery(
          "#regularlabeltextcolor, #regularlabelbackgroundcolor, #regularlabeltransparentbackground"
        ).show();
        jQuery(".single-serving, .servings-varied").show();
      } else if (isFormat("legacy_fda/adult/vertical")) {
        jQuery("#standardslider").show();

        jQuery(".remove-uppercase, .make-lowercase, .make-titlecase").show();
        jQuery(
          "#regularlabeltextcolor, #regularlabelbackgroundcolor, #regularlabeltransparentbackground"
        ).show();
        jQuery(".single-serving, .servings-varied").show();
      } else if (isFormat("canada/adult/vertical")) {
        jQuery("#newcanadaslider").show();

        jQuery(".servings-varied, .single-serving").hide();
        jQuery(".remove-uppercase, .make-lowercase, .make-titlecase").hide();
        jQuery(
          "#regularlabeltextcolor, #regularlabelbackgroundcolor, #regularlabeltransparentbackground"
        ).hide();
      } else if (isFormat("canada/adult/linear")) {
        jQuery("#newlinearcanadaslider").show();

        jQuery(".servings-varied, .single-serving").hide();
        jQuery(".remove-uppercase, .make-lowercase, .make-titlecase").hide();
        jQuery(
          "#regularlabeltextcolor, #regularlabelbackgroundcolor, #regularlabeltransparentbackground"
        ).hide();
      } else if (isFormat("canada/adult/tabular")) {
        jQuery("#newtabularcanadaslider").show();

        jQuery(".servings-varied, .single-serving").hide();
        jQuery(".remove-uppercase, .make-lowercase, .make-titlecase").hide();
        jQuery(
          "#regularlabeltextcolor, #regularlabelbackgroundcolor, #regularlabeltransparentbackground"
        ).hide();
      } else if (isFormat("canada/adult/vertical/as_prepared")) {
        jQuery("#as-packaged-description, #as-prepared-description").show();
        jQuery("#as-prepared-serving-size").show();

        jQuery("#canada-as-prepared-slider").show();

        jQuery(".servings-varied, .single-serving").hide();
        jQuery(".remove-uppercase, .make-lowercase, .make-titlecase").hide();
        jQuery(
          "#regularlabeltextcolor, #regularlabelbackgroundcolor, #regularlabeltransparentbackground"
        ).hide();
      } else if (isFormat("canada/adult/vertical/aggregate")) {
        jQuery("#ca-aggregate-slider-left, #ca-aggregate-slider-right, #slider-size2").show();

        jQuery(".servings-varied, .single-serving").hide();
        jQuery(".remove-uppercase, .make-lowercase, .make-titlecase").hide();
        jQuery(
          "#regularlabeltextcolor, #regularlabelbackgroundcolor, #regularlabeltransparentbackground"
        ).hide();
      } else if (isFormat("fda/adult/vertical")) {
        jQuery(".remove-uppercase, .make-lowercase, .make-titlecase").show();
        jQuery(
          "#regularlabeltextcolor, #regularlabelbackgroundcolor, #regularlabeltransparentbackground"
        ).show();
        jQuery(".single-serving, .servings-varied").show();

        syncDualColumnSliders();
      } else if (isFormat("legacy_fda/adult/tabular")) {
        jQuery("#tabularslider").show();

        jQuery(".remove-uppercase, .make-lowercase, .make-titlecase").show();
        jQuery(
          "#regularlabeltextcolor, #regularlabelbackgroundcolor, #regularlabeltransparentbackground"
        ).show();
        jQuery(".single-serving, .servings-varied").show();
      } else if (isFormat("fda/adult/tabular")) {
        jQuery(".remove-uppercase, .make-lowercase, .make-titlecase").show();
        jQuery(
          "#regularlabeltextcolor, #regularlabelbackgroundcolor, #regularlabeltransparentbackground"
        ).show();
        jQuery(".single-serving, .servings-varied").show();

        syncDualColumnSliders();
      } else if (isFormat("legacy_fda/adult/vertical/as_prepared")) {
        jQuery("#aggregateslider").show();

        jQuery(".remove-uppercase, .make-lowercase, .make-titlecase").show();
        jQuery(
          "#regularlabeltextcolor, #regularlabelbackgroundcolor, #regularlabeltransparentbackground"
        ).show();
        jQuery(".single-serving, .servings-varied").show();

        jQuery("#as-packaged-description, #as-prepared-description").show();
      } else if (isFormat("fda/adult/vertical/as_prepared")) {
        jQuery("#slider-size2").show();

        jQuery(".remove-uppercase, .make-lowercase, .make-titlecase").show();
        jQuery(
          "#regularlabeltextcolor, #regularlabelbackgroundcolor, #regularlabeltransparentbackground"
        ).show();
        jQuery(".single-serving, .servings-varied").show();
        jQuery("#newaspreparedsliderleft, #newaspreparedsliderright").show();

        jQuery("#as-prepared-description").show();
      } else if (isFormat("fda/adult/vertical/aggregate")) {
        jQuery("#slider-size2").show();

        jQuery(".remove-uppercase, .make-lowercase, .make-titlecase").show();
        jQuery(
          "#regularlabeltextcolor, #regularlabelbackgroundcolor, #regularlabeltransparentbackground"
        ).show();
        jQuery(".single-serving, .servings-varied").hide();
        jQuery("#newaggregatesliderleft, #newaggregatesliderright").show();
      } else if (isFormat("legacy_fda/infant/vertical")) {
        jQuery("#infantslider").show();

        jQuery(".servings-varied, .single-serving").hide();
        jQuery(".remove-uppercase, .make-lowercase, .make-titlecase").show();
        jQuery(
          "#regularlabeltextcolor, #regularlabelbackgroundcolor, #regularlabeltransparentbackground"
        ).show();
      } else if (isFormat("legacy_fda/child/vertical")) {
        jQuery("#childslider").show();

        jQuery(".servings-varied, .single-serving").hide();
        jQuery(".remove-uppercase, .make-lowercase, .make-titlecase").show();
        jQuery(
          "#regularlabeltextcolor, #regularlabelbackgroundcolor, #regularlabeltransparentbackground"
        ).show();
      } else if (isFormat("fda/infant/vertical")) {
        jQuery("#newinfantslider").show();

        jQuery(".remove-uppercase, .make-lowercase, .make-titlecase").show();
        jQuery(
          "#regularlabeltextcolor, #regularlabelbackgroundcolor, #regularlabeltransparentbackground"
        ).show();
        jQuery(".single-serving").show();
      } else if (isFormat("fda/child/vertical")) {
        jQuery("#newchildslider").show();

        jQuery(".remove-uppercase, .make-lowercase, .make-titlecase").show();
        jQuery(
          "#regularlabeltextcolor, #regularlabelbackgroundcolor, #regularlabeltransparentbackground"
        ).show();
        jQuery(".single-serving").show();
      }
    } else {
      jQuery("#regularlabeloptions").hide("fast");
      jQuery("#regularlabelwidth-chevron").removeClass("rotate-90");
    }
  });

  //Show extra label sections (allergens, manufactured, ingredient list) on click
  jQuery("#extrasectionsslidedown").on("click", () => {
    // logic for both showing and hiding
    if (jQuery("#extrasections").is(":hidden")) {
      jQuery("#extrasections").slideDown("fast", () => {
        jQuery("#extrasections").trigger("extrasections:opened");
      });
      jQuery("#extrasections-chevron").addClass("rotate-90");

      if (isFormat("legacy_fda/adult/linear")) {
        jQuery(
          ".conversiontoggle, .asterisksectiontoggle, .asterisksectionminitoggle, " +
            ".reverse-language-order, .canada-french-only-toggle, .canada-english-only-toggle"
        ).hide();
      } else if (isFormat("fda/adult/linear")) {
        jQuery(
          ".conversiontoggle, .asterisksectiontoggle, .asterisksectionminitoggle, " +
            ".reverse-language-order, .canada-french-only-toggle, .canada-english-only-toggle"
        ).hide();
      } else if (
        isFormat("legacy_fda/child/vertical") ||
        isFormat("legacy_fda/infant/vertical") ||
        isFormat("fda/child/vertical") ||
        isFormat("fda/infant/vertical") ||
        isFormat("fda/adult/vertical/as_prepared") ||
        isFormat("fda/adult/vertical/aggregate")
      ) {
        jQuery(
          ".conversiontoggle, .asterisksectiontoggle, .asterisksectionminitoggle, " +
            ".reverse-language-order, .canada-french-only-toggle, .canada-english-only-toggle"
        ).hide();
      } else if (isFormat("fda/adult/vertical")) {
        jQuery(
          ".conversiontoggle, .asterisksectiontoggle, .asterisksectionminitoggle, " +
            ".reverse-language-order, .canada-french-only-toggle, .canada-english-only-toggle"
        ).hide();
      } else if (isFormat("legacy_fda/adult/vertical")) {
        jQuery(".conversiontoggle, .asterisksectiontoggle, .asterisksectionminitoggle").show();
        jQuery(
          ".reverse-language-order, .canada-french-only-toggle, .canada-english-only-toggle"
        ).hide();
      } else if (
        isFormat("canada/adult/vertical") ||
        isFormat("canada/adult/linear") ||
        isFormat("canada/adult/vertical/as_prepared") ||
        isFormat("canada/adult/vertical/aggregate")
      ) {
        jQuery(".conversiontoggle, .asterisksectiontoggle, .asterisksectionminitoggle").hide();
        jQuery(
          ".reverse-language-order, .canada-french-only-toggle, .canada-english-only-toggle"
        ).show();
      } else if (isFormat("canada/adult/tabular")) {
        jQuery(".conversiontoggle, .asterisksectiontoggle, .asterisksectionminitoggle").hide();
        jQuery(".canada-french-only-toggle, .canada-english-only-toggle").hide();
        jQuery(".reverse-language-order").show();
      } else if (isFormat("legacy_fda/adult/tabular")) {
        jQuery(".conversiontoggle, .asterisksectionminitoggle").show();
        jQuery(
          ".asterisksectiontoggle, .reverse-language-order, .canada-french-only-toggle, " +
            ".canada-english-only-toggle"
        ).hide();
      } else if (isFormat("fda/adult/tabular")) {
        jQuery(
          ".conversiontoggle, .asterisksectiontoggle, .reverse-language-order, " +
            ".canada-french-only-toggle, .canada-english-only-toggle"
        ).hide();
        jQuery(".asterisksectionminitoggle").show();
      } else if (isFormat("legacy_fda/adult/vertical/as_prepared")) {
        jQuery(".conversiontoggle, .asterisksectiontoggle, .asterisksectionminitoggle").show();
        jQuery(
          ".reverse-language-order, .canada-french-only-toggle, .canada-english-only-toggle"
        ).hide();
      }
    } else {
      jQuery("#extrasections").hide("fast");
      jQuery("#extrasections-chevron").removeClass("rotate-90");
    }
  });

  jQuery(".panel-heading").on("click", function () {
    jQuery(this).toggleClass("is-active");
    jQuery(this).parent().toggleClass("is-active");
    saveOpenSections();
  });
};

export const showClaimsSectionsForLabel = () => {
  jQuery("#nutrition-claims").toggle(isFDA());
  jQuery("#canada-fop-symbols").toggle(isCanadian());
};

export const applyBioengineeredSection = () => {
  if (isFDA() || isLegacyFDA()) {
    jQuery(".bioengineered").show();
  } else if (isCanadian()) {
    jQuery("#bioengineered-claim").hide();
    jQuery(".bioengineered").hide();
  }
};

export function showProperAllergens() {
  if (isCanadian()) {
    $(
      "#allergen-list, #facility-allergen-list, #facility-allergen-list + .redundant-facility-allergens-warning, .agg-allergen-list"
    ).hide();

    if ($("#allergen-list-toggle").is(":checked")) {
      $(".allergen-list-canada-english, .allergen-list-canada-french").hide();
    } else {
      $("#new-canada-ingredients-allergens-table").show();
      $(".allergen-list-canada-english, .allergen-list-canada-french").show();
      if ($("#canada-english-only-toggle").is(":checked")) {
        $(".allergen-list-canada-french").hide();
      }
      if ($("#canada-french-only-toggle").is(":checked")) {
        $(".allergen-list-canada-english").hide();
      }
    }

    // facility allergens
    if ($("#facility-allergen-list-toggle").is(":checked")) {
      // hide canada facility allergens
      $(".facility-allergen-list-canada-english, .facility-allergen-list-canada-french").hide();
    } else {
      // show canada facility allergens
      $("#new-canada-ingredients-allergens-table").show();
      $(".facility-allergen-list-canada-english, .facility-allergen-list-canada-french").show();
      if ($("#canada-english-only-toggle").is(":checked")) {
        $(".facility-allergen-list-canada-french").hide();
      }
      if ($("#canada-french-only-toggle").is(":checked")) {
        $(".facility-allergen-list-canada-english").hide();
      }
    }
  } else {
    $("#gluten-facility-allergen-options").addClass("is-hidden");

    if ($("#allergen-list-toggle").is(":checked")) {
      $(
        "#allergen-list, .allergen-list-canada-english, .allergen-list-canada-french, .agg-allergen-list"
      ).hide();
    } else {
      $("#allergen-list, .agg-allergen-list").show();
      $(".allergen-list-canada-english, .allergen-list-canada-french").hide();
    }

    if ($("#facility-allergen-list-toggle").is(":checked")) {
      $(
        "#facility-allergen-list, #facility-allergen-list + .redundant-facility-allergens-warning, .facility-allergen-list-canada-english, .facility-allergen-list-canada-french"
      ).hide();
    } else {
      $(
        "#facility-allergen-list, #facility-allergen-list + .redundant-facility-allergens-warning"
      ).show();
      $(".facility-allergen-list-canada-english, .facility-allergen-list-canada-french").hide();
    }
  }
  hideNewCanadaIngredientsTable();
}

export function showProperIngredients() {
  $("#recipe-show-ingredient-list").hide();
  $(".agg-ingredient-list").hide();
  $(".recipe-show-new-canada-ingredient-list").hide();
  $(".recipe-show-new-canada-french-ingredient-list").hide();
  if ($("#ingredient-list-toggle").is(":checked")) {
    // do nothing - already hidden
  } else if (isCanadian()) {
    $("#new-canada-ingredients-allergens-table").show();
    $(".recipe-show-new-canada-ingredient-list").show();
    $(".recipe-show-new-canada-french-ingredient-list").show();
    if ($("#canada-english-only-toggle").is(":checked")) {
      $(".recipe-show-new-canada-french-ingredient-list").hide();
    }
    if ($("#canada-french-only-toggle").is(":checked")) {
      $(".recipe-show-new-canada-ingredient-list").hide();
    }
  } else {
    $("#recipe-show-ingredient-list").show();
    $(".agg-ingredient-list").show();
  }
  hideNewCanadaIngredientsTable();
}

export function hideNewCanadaIngredientsTable() {
  let ingredients_table_text_length = 0;
  // see if there's any visible text
  $("#new-canada-ingredients-allergens-table div:visible")
    .not(".bilingual, .bilingual-english, .bilingual-french")
    .each(function () {
      ingredients_table_text_length += $(this).html().trim().length;
    });
  if (ingredients_table_text_length == 0) {
    $("#new-canada-ingredients-allergens-table").hide();
  } else {
    $("#new-canada-ingredients-allergens-table").show();
  }
}
